import * as React from 'react'

import styles from './CategorySelect.module.css'

export type CategorySelectOption = {
  value: string
  label: string
}

export type CategorySelectProps = {
  /** Ties the visible label to the control; the caller owns it so it stays unique on the page. */
  id: string
  label: string
  options: CategorySelectOption[]
  value: string
  onChange: (value: string) => void
}

/**
 * The bold pill dropdown in the Top 10 header.
 *
 * TODO: swap for Plume Select. `plume.Select` exists but draws its own chrome — a square 50px
 * button with a 1px sand border and a blue hover — so wearing this page's pill would mean
 * overriding its generated classes and restyling its drawer. A native control also needs no
 * client-side JS to open, which matters on a page that is prerendered and hydrated late, and it
 * keeps the platform's own list on mobile.
 */
export function CategorySelect({ id, label, options, value, onChange }: CategorySelectProps): React.ReactElement {
  return (
    <div className={styles.catsel}>
      <label className={styles.catsel__label} htmlFor={id}>
        {label}
      </label>
      {/* Wraps both so the hover shift moves the chevron with the pill it sits on. */}
      <div className={styles.catsel__box}>
        <select
          id={id}
          className={styles.catsel__select}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <svg className={styles.catsel__chev} viewBox="0 0 14 9" fill="none" aria-hidden="true">
          <path d="M2 2l5 5 5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  )
}
